import style from "./style.scss";
import { mergeClasses } from "../../helpers";

const AccordionPreview = ({
  src,
  prefix = null,
  heading,
  headingAs = null,
  wide,
}) => {
  const Tag = headingAs || "div";

  return (
    <div
      class={mergeClasses([style.accordionPreview, wide ? style.wide : null])}
    >
      <div class={style.image}>
        <img src={src} />
      </div>
      <Tag class={style.text}>
        {prefix ? <span class={style.reason}>{prefix}</span> : null}
        <span class={style.title}>{heading}</span>
      </Tag>
    </div>
  );
};

export default AccordionPreview;
